<template>
  <layout>
    <h4>
      Menu
      <router-link
        :to="{ name: 'menus.create' }"
        class="btn btn-sm btn-primary">Create</router-link>
    </h4>
    <pages-base-table
      :resource="resource"/>
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceForm from './Form.vue';
import Proxy from './Proxy';
import PagesBaseTable from '@/components/PagesBaseTable'

const resourceBase = 'menus';

export default {
  name: 'MenuIndex',

  components: {
    PagesBaseTable,
    Layout,
    ResourceForm,
  },

  data() {
    return {
      resource: {
        base: resourceBase,
        proxy() {
          return new Proxy();
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'position',
            label: 'Order item',
            sortable: true,
          },
          {
            key: 'created_at',
            label: 'Created',
            sortable: true,
          },
          // define column fields here
        ],

        // override search fields here using fields schema
        // searchFields: [
        // ],

        // define custom row actions
        // rowActions(item) {
        //   return [];
        // },

        // define custom bulk actions
        // bulkActions() {
        //   return [];
        // },
      },
    };
  },

};
</script>
